export { SearchNoResults, type SearchNoResultsProps } from './SearchNoResults';
